import React from "react";



export default function Header() {
    return(
        <header className="p-4 bg-white">
  <div className="flex items-center">
    
    <h1 translate="no" className="bg-gradient-to-r from-purple-800 to-pink-800 text-3xl font-bold bg-clip-text text-transparent">
      Storii
    </h1>

    <div className="flex space-x-4 ml-auto">
      <a href="#">Contact</a>
      <a href="/about">About</a>
    </div>

  </div>
</header>
    )
}